export default __webpack_public_path__ + "static/launch-df02add51b252cd6b49d405a89b1665b.svg";